export default "__VITE_ASSET__BUq9GvfL__"